import { isDev } from "../../lib";
import { Image } from "../../primitives/image";
import { getIconSize } from "../../tokens";
import { serviceIconRegistry } from "./service-icon-registry";
import type { ServiceIconProps } from "./types";

export const ServiceIcon = ({
  name,
  accessibilityLabel,
  size = "2xl",
  className,
  testID,
}: ServiceIconProps) => {
  // An own key only: a cast name such as "toString" would find Object's method
  const iconSrc = Object.prototype.hasOwnProperty.call(serviceIconRegistry, name)
    ? serviceIconRegistry[name]
    : undefined;
  const iconSize = getIconSize(size);

  if (!iconSrc) {
    if (isDev()) console.warn(`ServiceIcon: Icon "${name}" not found in registry`);
    return null;
  }

  return (
    <Image
      src={iconSrc}
      // Decorative unless labelled: its registry name ("home-massage") isn't a
      // label, and the text beside it usually names the service
      alt={accessibilityLabel ?? ""}
      width={iconSize}
      height={iconSize}
      loading="lazy"
      // Image merges it last with `cn`, onto the image itself
      className={className}
      testID={testID}
    />
  );
};

ServiceIcon.displayName = "ServiceIcon";
